import { h, render } from 'vue'
import ConfirmModal from '@/components/element/modals/ConfirmModal.vue'

export default {
  install(app) {
    if (typeof window === 'undefined') {
      return
    }

    app.config.globalProperties.$confirm = ({ title, description }) => {
      return new Promise((resolve) => {
        const container = document.createElement('div')
        document.body.appendChild(container)

        const vnode = h(ConfirmModal, {
          title,
          description,
          onResolve: (result) => {
            render(null, container)
            container.remove()
            resolve(result)
          }
        })

        render(vnode, container)
      })
    }
  }
}
